import { render, staticRenderFns } from "./CompHeroHeadline.vue?vue&type=template&id=6f8d6d7c&scoped=true&"
import script from "./CompHeroHeadline.vue?vue&type=script&lang=ts&"
export * from "./CompHeroHeadline.vue?vue&type=script&lang=ts&"
import style0 from "./CompHeroHeadline.vue?vue&type=style&index=0&id=6f8d6d7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8d6d7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VProgressCircular,VRow})
